import { render } from "./ThePanelTopBar.vue?vue&type=template&id=17c02a60"
import script from "./ThePanelTopBar.vue?vue&type=script&lang=js"
export * from "./ThePanelTopBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])